import { adminClient, emailOTPClient } from 'better-auth/client/plugins';
import { nextCookies } from 'better-auth/next-js';
import { createAuthClient } from 'better-auth/react';

import { env } from './env';

export const authClient = createAuthClient({
  baseURL: env.NEXT_PUBLIC_API_URL,
  plugins: [emailOTPClient(), adminClient(), nextCookies()],
  fetchOptions: {
    credentials: 'include', // Required for cross-origin cookie handling
  },
});
